export enum ImportStatus {
  toValid = 'to_valid',
  inProgress = 'in_progress',
  validated = 'validated',
}
